export default __webpack_public_path__ + "static/media/ferry.1519293f.svg";